<template>
    <v-app>
        <auto-logout/>
        <router-view></router-view>
        <service-worker-alert/>
    </v-app>
</template>

<script>
    /*eslint-disable */
    import {mapActions, mapGetters} from "vuex";
    import axios from "axios";
    import moment from "moment-timezone";
    import ServiceWorkerAlert from '@/components/shared/ServiceWorkerAlert';
    import AutoLogout from './components/AutoLogout';

    export default {
        components: {ServiceWorkerAlert, AutoLogout},
        name: "App",
        isLoggedIn: false,
        data: () => ({
            allowedRoutePath: ['/forgot-password', '/reset-password', '/privacy-policy', '/terms-of-service']
        }),
        computed: {
            ...mapGetters(["isLoggedIn"])
        },
        methods: {
            ...mapActions(["logout"])
        },
        created() {
            if (!this.isLoggedIn && !this.allowedRoutePath.includes(this.$route.path) && !this.$route.path.startsWith(this.allowedRoutePath[1])) {
                if (window.location.pathname !== '/') {
                    let path = '/';

                    if (!window.location.href.includes('/?next=')) {
                        const nextPath = window.location.href.replace(window.location.origin, '');
                        path = '/?next=' + nextPath;
                    }

                    this.$router.push(encodeURI(path)).catch((error) => {
                        console.log({error});
                    });
                }
            }

            axios.interceptors.response.use(
                response => {
                    moment.tz.setDefault(moment.tz.guess());
                    return response;
                },
                error => {
                    if (!error.response) {
                        //Todo: Show a generic error Toast (e.g. Server error, please retry)
                        return;
                    }

                    const {response: {status}} = error;

                    if (status === 401) {
                        // If unauthorize redirect to login
                        this.logout({
                            commit: () => {
                            }
                        });
                        window.location.href = '/';
                    }
                    return Promise.reject(error);
                }
            );
        },
    };
</script>

<style>

/* Global Styles for SweetAlert2 */
.swal-custom-font {
    font-family: sans-serif;
}

.swal2-title, .swal2-html-container {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
}

.swal2-confirm {
  color: #ffffff !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
}

.swal2-cancel {
  color: #ffffff !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
}
</style>
